import { render, staticRenderFns } from "./DateTimeISO8601.vue?vue&type=template&id=60a4a8dd&scoped=true&"
import script from "./DateTimeISO8601.vue?vue&type=script&lang=js&"
export * from "./DateTimeISO8601.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a4a8dd",
  null
  
)

export default component.exports